import {
  createDataReducerSimpleFetch,
  createDataReducerSimpleSubmit,
} from "shared/redux-store/defaults";
import reduceReducers from "reduce-reducers";

const orderUnitWizardDataReducerFetch = createDataReducerSimpleFetch(
  "ORDER_UNIT_WIZARD_PRODUCTS",
  ["products"],
);

const orderUnitWizardDataReducerSubmit = createDataReducerSimpleSubmit(
  "ORDER_UNIT_WIZARD_PRODUCTS",
);

export default reduceReducers(
  orderUnitWizardDataReducerFetch,
  orderUnitWizardDataReducerSubmit,
);
